import { createSelector } from 'reselect'

export const getCurrentUser = (state) => state.currentUser
export const getTimeZone = createSelector([getCurrentUser], (currentUser) => currentUser.timeZone)
